import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=55329490&scoped=true&"
import script from "./FaqEdit.vue?vue&type=script&lang=js&"
export * from "./FaqEdit.vue?vue&type=script&lang=js&"
import style0 from "./FaqEdit.vue?vue&type=style&index=0&id=55329490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55329490",
  null
  
)

export default component.exports